import { gql } from "@apollo/client";

// Auto-Responder fragments
export const AUTO_RESPONDER_FRAGMENT = gql`
  fragment AutoResponderFields on AutoResponder {
    id
    tenantId
    name
    content
    isActive
    usageCount
    tags
    conversationIds
    createdAt
    updatedAt
    version
  }
`;

// Queries
export const LIST_AUTO_RESPONDERS = gql`
  query ListAutoResponders(
    $filter: AutoResponderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAutoResponders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        ...AutoResponderFields
      }
      nextToken
      totalCount
    }
  }
  ${AUTO_RESPONDER_FRAGMENT}
`;

export const GET_AUTO_RESPONDER = gql`
  query GetAutoResponder($id: ID!) {
    getAutoResponder(id: $id) {
      ...AutoResponderFields
    }
  }
  ${AUTO_RESPONDER_FRAGMENT}
`;

export const GET_AUTO_RESPONDER_ANALYTICS = gql`
  query GetAutoResponderAnalytics(
    $autoResponderId: ID!
    $dateFrom: String
    $dateTo: String
  ) {
    getAutoResponderAnalytics(
      autoResponderId: $autoResponderId
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      autoResponderId
      totalUsage
      smsUsage
      chatUsage
      responseRate
      deviceBreakdown {
        PHONE
        DESKTOP
        TABLET
        OTHER
      }
      conversationBreakdown {
        conversationId
        usage
      }
      dailyUsage {
        date
        usage
      }
    }
  }
`;

// Mutations
export const CREATE_AUTO_RESPONDER = gql`
  mutation CreateAutoResponder($input: CreateAutoResponderInput!) {
    createAutoResponder(input: $input) {
      ...AutoResponderFields
    }
  }
  ${AUTO_RESPONDER_FRAGMENT}
`;

export const UPDATE_AUTO_RESPONDER = gql`
  mutation UpdateAutoResponder($input: UpdateAutoResponderInput!) {
    updateAutoResponder(input: $input) {
      ...AutoResponderFields
    }
  }
  ${AUTO_RESPONDER_FRAGMENT}
`;

export const DELETE_AUTO_RESPONDER = gql`
  mutation DeleteAutoResponder($id: ID!) {
    deleteAutoResponder(id: $id)
  }
`;

export const ATTACH_AUTO_RESPONDER_TO_CONVERSATION = gql`
  mutation AttachAutoResponderToConversation(
    $autoResponderId: ID!
    $conversationId: ID!
  ) {
    attachAutoResponderToConversation(
      autoResponderId: $autoResponderId
      conversationId: $conversationId
    ) {
      ...AutoResponderFields
    }
  }
  ${AUTO_RESPONDER_FRAGMENT}
`;

export const DETACH_AUTO_RESPONDER_FROM_CONVERSATION = gql`
  mutation DetachAutoResponderFromConversation(
    $autoResponderId: ID!
    $conversationId: ID!
  ) {
    detachAutoResponderFromConversation(
      autoResponderId: $autoResponderId
      conversationId: $conversationId
    ) {
      ...AutoResponderFields
    }
  }
  ${AUTO_RESPONDER_FRAGMENT}
`;

// Subscriptions
export const ON_AUTO_RESPONDER_UPDATED = gql`
  subscription OnAutoResponderUpdated($tenantId: ID!) {
    onAutoResponderUpdated(tenantId: $tenantId) {
      ...AutoResponderFields
    }
  }
  ${AUTO_RESPONDER_FRAGMENT}
`;

export const ON_AUTO_RESPONDER_USAGE_UPDATED = gql`
  subscription OnAutoResponderUsageUpdated($autoResponderId: ID!) {
    onAutoResponderUsageUpdated(autoResponderId: $autoResponderId) {
      ...AutoResponderFields
    }
  }
  ${AUTO_RESPONDER_FRAGMENT}
`;

// Analytics queries
export const GET_TENANT_AUTO_RESPONDER_ANALYTICS = gql`
  query GetTenantAutoResponderAnalytics($dateFrom: String, $dateTo: String) {
    getTenantAutoResponderAnalytics(dateFrom: $dateFrom, dateTo: $dateTo) {
      tenantId
      totalAutoResponders
      totalUsage
      smsUsage
      chatUsage
      averageResponseRate
      deviceBreakdown {
        PHONE
        DESKTOP
        TABLET
        OTHER
      }
      topAutoResponders {
        autoResponderId
        name
        usage
        responseRate
      }
    }
  }
`;
